var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 98,
    viewBox: "0 0 140 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_289)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49,
    r: 90,
    fill: "url(#paint0_linear_72_289)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49,
    r: 71,
    fill: "url(#paint1_linear_72_289)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7753 51.9802L52.2958 48.8183L56.3161 42.3256C59.7659 34.6469 58.7384 26.9814 58.7384 26.9814C53.6905 25.872 40.6364 26.4901 39.527 27.4727C38.4176 28.4553 24.9964 37.6925 22.7802 39.2932C20.564 40.894 16.9927 45.0807 16.9927 45.0807L12.6819 49.1644C15.0592 50.0704 19.135 53.6601 24.3677 58.8929C24.3677 58.8929 36.4497 56.2884 39.7753 51.9775V51.9802Z",
    fill: "#FFCC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4054 42.2513L39.5057 44.9166L39.4952 44.9113C38.2907 47.801 32.3289 52.3258 32.2681 52.3734L32.4161 52.5689C32.6511 52.3919 37.9684 48.3531 39.5216 45.4184L39.7699 51.9772C36.4443 56.288 24.3622 58.8925 24.3622 58.8925C19.1322 53.6624 15.0564 50.0727 12.6764 49.164L12.3093 49.5127L21.7921 66.6293L26.9641 61.8272C35.953 64.5373 40.7551 55.7941 40.7551 55.7941C49.3452 53.0153 55.0613 39.4646 57.4624 34.1209L39.4001 42.2487L39.4054 42.2513Z",
    fill: "#E2AD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8699 33.0172C41.8699 33.0172 43.151 49.7112 42.7812 56.3598C42.7812 56.3598 64.0366 48.0894 96.3945 56.4126C96.3945 56.4126 102.428 43.5091 101.442 21.8095C101.442 21.8095 76.2273 16.5134 41.8699 33.0146V33.0172Z",
    fill: "#5B912C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9498 25.3041C94.9498 24.6648 95.1532 24.0758 95.4966 23.595C88.9114 23.1698 69.6847 22.8211 46.3342 33.2707C46.807 33.6907 47.1055 34.3062 47.1055 34.9929C47.1055 36.2608 46.0912 37.2884 44.8391 37.2884C44.6304 37.2884 44.4323 37.2567 44.2395 37.2038L44.4403 51.2036C44.8048 50.95 45.2433 50.8021 45.7187 50.8021C46.5296 50.8021 47.2376 51.2353 47.6391 51.8824C54.6363 50.5115 70.4397 47.9784 91.368 52.2892C91.0114 51.8005 90.7975 51.1983 90.7975 50.5459C90.7975 48.9266 92.0944 47.6138 93.6925 47.6138C94.7359 47.6138 95.6472 48.1738 96.157 49.0112C96.8966 46.0791 99.4192 35.3786 98.9279 28.0195C98.5924 28.1568 98.2279 28.2335 97.8475 28.2335C96.2494 28.2335 94.9525 26.9206 94.9525 25.3014L94.9498 25.3041Z",
    fill: "#CBF4A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4591 41.6967C23.4591 41.6967 27.8915 40.2201 28.3854 39.9718C28.8767 39.7261 37.7441 32.5836 45.6262 34.1844C45.6262 34.1844 52.2748 30.9829 54.8608 32.5836C57.4468 34.1844 54.2453 39.7261 45.7477 39.9718C45.7477 39.9718 41.0671 44.6525 36.389 45.7592",
    fill: "#E2AD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6437 42.0056C23.6437 42.0056 28.076 40.5291 28.57 40.2808C29.0613 40.0351 37.9287 32.8926 45.8108 34.4933C45.8108 34.4933 52.4594 31.2919 55.0453 32.8926C57.6313 34.4933 54.4299 40.0351 45.9323 40.2808C45.9323 40.2808 41.2516 44.9614 36.5736 46.0682",
    fill: "#FFCC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8743 33.3919C68.9615 33.9968 68.5388 34.5594 67.9339 34.6466L58.3428 36.0122C57.7379 36.0994 57.1753 35.6767 57.0907 35.0718C57.0036 34.467 57.4262 33.9043 58.0311 33.8172L67.6222 32.4515C68.2271 32.3643 68.7898 32.787 68.8769 33.3919H68.8743Z",
    fill: "#5B912C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0556 38.3631C68.1428 38.968 67.7202 39.5307 67.1153 39.6178L57.5241 40.9835C56.9192 41.0706 56.3566 40.648 56.2694 40.0431C56.1823 39.4382 56.6049 38.8756 57.2098 38.7884L66.8009 37.4228C67.4058 37.3356 67.9685 37.7582 68.0556 38.3631Z",
    fill: "#5B912C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3988 43.4109C65.486 44.0158 65.1611 44.5653 64.6751 44.6339L56.9805 45.7301C56.4945 45.7988 56.0296 45.363 55.945 44.7581C55.8579 44.1532 56.1828 43.6038 56.6688 43.5351L64.3634 42.4389C64.8494 42.3702 65.3143 42.806 65.3988 43.4109Z",
    fill: "#5B912C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7224 37.7125C92.1716 31.9266 87.8455 26.8721 82.0596 26.4228C76.2738 25.9736 71.2193 30.2997 70.77 36.0856C70.3207 41.8714 74.6469 46.926 80.4327 47.3752C86.2186 47.8245 91.2731 43.4983 91.7224 37.7125Z",
    fill: "#5B912C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3336 34.5753C48.3336 34.5753 48.1645 36.8178 50.4626 37.9405C50.4626 37.9405 55.8459 36.9552 54.4406 34.0707C53.1094 31.3421 48.4472 34.6307 48.3362 34.5753H48.3336Z",
    fill: "#FFE5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9712 70.9851C23.2607 75.8322 4.82595 87.4995 0 90.4791V53.1843L9.03115 47.3414C9.03115 47.3414 10.6715 44.8796 13.4635 48.818C16.2529 52.759 24.7927 65.4011 23.9712 70.9851Z",
    fill: "#9B5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.403 67.2342L0 79.9423V77.1503L17.0955 65.3456C17.6185 64.9837 18.3344 65.1158 18.6936 65.6388C19.0555 66.1618 18.9261 66.875 18.403 67.2369V67.2342Z",
    fill: "#A86C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0623 72.6676C18.0623 73.8246 17.1246 74.7623 15.9677 74.7623C14.8107 74.7623 13.873 73.8246 13.873 72.6676C13.873 71.5107 14.8107 70.5729 15.9677 70.5729C17.1246 70.5729 18.0623 71.5107 18.0623 72.6676Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.5166 71.9517C16.5166 72.5302 16.0464 72.9977 15.4706 72.9977C14.8947 72.9977 14.4246 72.5302 14.4246 71.9517C14.4246 71.3732 14.8921 70.9057 15.4706 70.9057C16.0491 70.9057 16.5166 71.3732 16.5166 71.9517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1651 76.7725C13.1651 77.9295 12.2273 78.8672 11.0704 78.8672C9.91343 78.8672 8.97571 77.9295 8.97571 76.7725C8.97571 75.6156 9.91343 74.6779 11.0704 74.6779C12.2273 74.6779 13.1651 75.6156 13.1651 76.7725Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.6221 76.0567C11.6221 76.6352 11.1519 77.1027 10.5761 77.1027C10.0003 77.1027 9.53009 76.6325 9.53009 76.0567C9.53009 75.4809 9.99763 75.0107 10.5761 75.0107C11.1546 75.0107 11.6221 75.4809 11.6221 76.0567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0843 35.4211H84.9614L85.9976 33.9966H83.0482C82.894 33.3247 82.5446 32.8119 82.1277 32.4244H84.9639L86 31H78.0361L77 32.4244H79.4675C80.0386 32.7447 80.7494 33.2665 81.0795 33.9966H78.0361L77 35.4211H81.2048C80.9253 36.8611 79.6482 37.4009 79.0313 37.4009H77.2386L83.2627 43H85.5036L80.7494 38.5812C80.7494 38.5812 82.7614 37.8018 83.0867 35.4211H83.0843Z",
    fill: "#CBF4A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_289",
    x1: 3.95402,
    y1: 11.4277,
    x2: 126.583,
    y2: 150.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_72_289",
    x1: 13.6748,
    y1: 19.3596,
    x2: 110.415,
    y2: 129.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.871841733c4c692ec23ce53bb6ef5f10.svg";
export { ForwardRef as ReactComponent };